import { Select } from "antd";
import React from "react";

const CustomSelect = ({
  className,
  onChange = () => {},
  options = [],
  defaultValue,
  disabled=false
}) => {
  return (
    <div className={`${className ? className : ""}`}>
      <select
        className="form-select form-select-sm"
        placeholder=""
        aria-label="Default select example"
        onChange={onChange}
        disabled={disabled}
      >
         <option value="" disabled selected hidden>
            Gender
          </option>
        {options.map((ei, i) =>{ 
          let value = 0
          return(
          <option
            key={ei.value}
            value={ei.value}
            disabled={i === 0 ? true : false}
            selected={value === i ? true : false}
          >
            {ei.label}
          </option>
        )})}
      </select>
      {/* <Select defaultValue={defaultValue} options={options} onChange={onChange} disabled={disabled} /> */}
    </div>
  );
};

export default CustomSelect;
